import React from 'react';
import Grid from '../Grid';
import Button from '../../atoms/UI/buttons/Button';
import Icon from '../../atoms/UI/Icon/Icon';
import {useTranslation} from "react-i18next";
import ErrorMessage from '@/components/atoms/UI/forms/ErrorMessage/ErrorMessage';
import styled from 'styled-components';
import SuccessMessage from '@/components/atoms/UI/forms/SuccessMessage/SuccessMessage';
import { basicColor } from '@/styles/template';
import { boolean } from 'yup';


type ErrorWithReloadProps = {
    error?: string;
    onReload?: () => void;
    transparent?: boolean;
}

const Error = styled.p<{ transparent?: boolean }>`
    color: ${({ transparent, theme }) =>
        transparent ? basicColor.white : theme.color.Text};
`;


const ErrorWithReload: React.FC<ErrorWithReloadProps> = ({error, onReload, transparent}) => {
    const { t } = useTranslation();
    const text_reload = t('reload' as any);

    const reload = () => {
        if (onReload) {
            onReload();
        } else {
            window.location.reload();
        }
    }

    return (
        <Grid col='1' gap='2' margin='2' centeredContent>
            <Error transparent={transparent}>{error}</Error>
            <Button type='button' transparent={transparent} light={!transparent} autoWidth onClick={reload}>
                <Icon name='Repeat'/>{text_reload}
            </Button>
        </Grid>
    )
}

export default ErrorWithReload